import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@arsnovasystems/ars-front-lib';
import { Stack } from '@mui/material';

/**
 * LastStep
 *
 * @returns JSX of the component
 */
export function LastStep() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goTo = () => {
    void navigate('/');
  };

  return (
    <>
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography>{t('ik.lastStep.save.success')}</Typography>
        <Button
          sx={{ marginTop: 2 }}
          onClick={goTo}
        >
          {t('ik.proceed.to.my.console')}
        </Button>
      </Stack>
    </>
  );
}
